export const getShortNameForMeasurementGroup = (description: string | null | undefined) => {
  if (!description) return '';
  if (description.length <= 3) return description;
  const match = description.match(/\b[^\s]/gi); // First letter of every word
  if (!match) return description.substring(0, 3);
  return match
    .reduce((left, right) => left + right)
    .substring(0, 3)
    .toUpperCase();
};
